import { render } from "./NovedadesGastos.vue?vue&type=template&id=90826fd6&scoped=true"
import script from "./NovedadesGastos.vue?vue&type=script&lang=js"
export * from "./NovedadesGastos.vue?vue&type=script&lang=js"

import "./NovedadesGastos.vue?vue&type=style&index=0&id=90826fd6&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90826fd6"]])

export default __exports__